<template>
  <Tab
    header="How can you reduce your CO2 footprint?"
    :loading="loadingTips"
    :tabs="tips"
    :company="getUserCompany()"
  ></Tab>
</template>

<script>
import Tab from '@/components/Tabs/Tab';
import TipsByConsumptionCategoryController from '@/controllers/Consumption/TipsByConsumptionCategoryController';
export default {
  name: 'ConsumptionCategoryTips',
  components: { Tab },
  props: {
    consumption_category_id: Number,
  },
  data() {
    return {
      loadingTips: false,
      tips: [
        {
          id: 1,
          name: 'Tip 1',
          title: 'Best lighting is natural lighting',
          body: 'A maintenance facility can take advantage of natural light by installing skylights in the roof to allow sunlight to filter into the work areas.  Pair this approach with light sensors and the demand for electricity will go down and the staff will have great lighting to work in. Lighting systems are available that measure the amount of natural light and then adjust the light level inside by  increasing or decreasing the dimmer function on each zoned area.  The best part is that it is automatic on',
        },
        { id: 2, name: 'Tip 2', title: 'Improve that', body: 'You can do something better 2' },
        { id: 3, name: 'Tip 3', title: 'Improve it', body: 'You can do something better 3' },
        { id: 4, name: 'Tip 4', title: 'Improve that', body: 'You can do something better 4' },
      ],
      questions: null,
    };
  },
  created() {
    this.getConsumptionTips();
  },
  methods: {
    async getConsumptionTips() {
      this.loadingTips = true;
      this.questions = await TipsByConsumptionCategoryController.index(this.consumption_category_id);
      let tips = [];
      for (let i = 0; i < this.questions.length; i++) {
        let tip = {
          id: i + 1,
          name: 'Tip ' + (i + 1),
          title: this.questions[i].dashboard_element.headline,
          body: this.questions[i].description,
          question: this.questions[i],
          answer: this.questions[i].answer,
        };
        tips.push(tip);
      }
      this.tips = tips;
      this.loadingTips = false;
    },
    getUserCompany() {
      return this.$store.getters.company;
    },
  },
};
</script>

<style scoped></style>
